export default class ResourceHttp {
  constructor(http, resource) {
    this.http = http;
    this.resource = resource;
  }

  all() {
    return this.http.get(this.resource);
  }

  find(id) {
    return this.http.get(`${this.resource}/${id}`);
  }

  store(data) {
    return this.http.post(this.resource, data);
  }

  update(data, id) {
    return this.http.put(`${this.resource}/${id}`, data);
  }

  updateFile(data, id) {
    data.append('_method', 'PUT');
    return this.http.post(`${this.resource}/${id}`, data);
  }

  destroy(id) {
    return this.http.delete(`${this.resource}/${id}`);
  }

  page(page) {
    return this.http.get(this.resource, {
      params: {
        page,
      },
    });
  }

  pageSort(params) {
    let orderBy = null;
    let sortedBy = null;
    let search = null;
    const { page, sortBy, sortDesc, itemsPerPage, searchBy, consulta } = params;

    if (sortBy.length === 1 && sortDesc.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      orderBy = sortBy[0];
      if (sortDesc[0] === false) {
        sortedBy = 'asc';
      } else {
        sortedBy = 'desc';
      }
    }
    if (searchBy !== '' || searchBy.length > 2) {
      search = searchBy;
    }
    return this.http.get(this.resource, {
      params: {
        page,
        orderBy,
        sortedBy,
        itemsPerPage,
        search,
        consulta,
      },
    });
  }

  pageSortBasic(params) {
    let orderBy = null;
    let sortedBy = null;
    let search = null;
    const resourceBasic = true;
    const { page, sortBy, sortDesc, itemsPerPage, searchBy } = params;

    if (sortBy.length === 1 && sortDesc.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      orderBy = sortBy[0];
      if (sortDesc[0] === false) {
        sortedBy = 'asc';
      } else {
        sortedBy = 'desc';
      }
    }
    if (searchBy !== '' || searchBy.length > 2) {
      search = searchBy;
    }
    return this.http.get(this.resource, {
      params: {
        page,
        orderBy,
        sortedBy,
        itemsPerPage,
        search,
        resourceBasic,
      },
    });
  }

  // Remover caso o metodo SEARCH esteja de forma correta
  listFilter(params) {
    let orderBy = null;
    let sortedBy = null;
    let search = null;
    let searchJoin = null;
    let filter = null;

    const { page, sortBy, sortDesc, itemsPerPage, searchBy, searchJoinAnd, filterBy } = params;

    if (sortBy) {
      orderBy = sortBy;
      if (sortDesc === true) {
        sortedBy = 'desc';
      }
    }
    if (searchBy) {
      search = searchBy;
    }
    if (filterBy) {
      filter = filterBy;
    }
    if (searchJoinAnd === true) {
      searchJoin = 'and';
    }
    return this.http.get(this.resource, {
      params: {
        page,
        itemsPerPage,
        search,
        orderBy,
        sortedBy,
        searchJoin,
        filter,
      },
    });
  }

  search(params) {
    let orderBy = null;
    let sortedBy = null;
    let search = null;
    let searchJoin = null;
    let filter = null;

    const { page, sortBy, sortDesc, itemsPerPage, searchBy, searchJoinAnd, filterBy } = params;

    if (sortBy) {
      orderBy = sortBy;
      if (sortDesc === true) {
        sortedBy = 'desc';
      }
    }
    if (searchBy) {
      search = searchBy;
    }
    if (filterBy) {
      filter = filterBy;
    }
    if (searchJoinAnd === true) {
      searchJoin = 'and';
    }

    return this.http.get(`${this.resource}/search`, {
      params: {
        search,
        page,
        itemsPerPage,
        orderBy,
        sortedBy,
        searchJoin,
        filter,
      },
    });
  }

  list() {
    return this.http.get(`${this.resource}/list`);
  }
}
